import { matchRoutes, useParams, type RouteMatch, type RouteObject } from 'react-router';

import { APP_ROUTES } from '@/assets/MenuItems';

import { useRouteMatch } from '@/hooks/useRouteMatch';
import { useTargetElement } from '@/hooks/useTargetElement';
import { useMediaQuery } from '@datanomik/core-ui';

type MenuRoute = RouteObject & Record<string, any>;

const getAppSidebarMenuElement = () => document.getElementById('App-Slot-Sidebar-Menu');

export const useSettingsMenu = ({ location }) => {
  const { workspace } = useParams();
  const isMobile = useMediaQuery('(max-width: 599.95px)');
  const isMobileMd = useMediaQuery('(max-width: 899.95px)');

  const menuMatchRoutes = matchRoutes<MenuRoute>(APP_ROUTES, `/${workspace}/${location}`);

  const { length, [length - 1]: routeItem } = menuMatchRoutes;
  const showTabletTabs = useMediaQuery('(min-width: 600px) and (max-width: 899.95px)');

  const { targetElement: sidebarMenuElement } = useTargetElement(
    getAppSidebarMenuElement,
  );

  const { params, route } = useRouteMatch(APP_ROUTES) as RouteMatch<string, MenuRoute>;
  const extraLocation = `${location}/${route.path}`;
  const currentTab = `/${params?.workspace}/${route?.parent || extraLocation}`;

  return {
    routeItem,
    isMobile,
    currentTab,
    isMobileMd,
    showTabletTabs,
    sidebarMenuElement,
  };
};
